module.exports = __webpack_public_path__ + "img/5.80cc3992.png";